import { Card } from "antd";
import styles from "../../../deliveryServices/DeliveryServices.module.css";

function NewMerchantCard() {
  return (
    <Card
      className={styles.dsCardStyle}
      style={{
        backgroundColor: "rgba(52, 199, 89, 0.1)",
        borderColor: "#34C759",
      }}
    >
      <strong style={{ color: "#34C759" }}>
        DoorDash will notify you once your account is ready.
      </strong>
      <p className={styles.dsFormLabels}>
        Only use this feature after receiving the green light from DoorDash.
        <br />
        <br />
        Click <b>Confirm</b> only after you’ve received your DoorDash account.
        If you need clarification or assistance, reach out to Customer Service
        at
      </p>
      <p className={styles.dsFormLabels}>
        <b>(818) 235-1327</b>.
      </p>
    </Card>
  );
}

export default NewMerchantCard;
